/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Pagination utils
define('global/Pagination',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    var pageSize;
    var page;
    var sortBy;
    var sortOrder;
    var sortAscending;
    var filterMin;
    var filterMax;
    var totalPages;
    var totalItems;
    var startIndex;
    var endIndex;
    var prefix;
    var filters = [];

    var callback;

    function setCallback(c) {
        callback = c;
    }

    function getPagingObj() {
        return {
            pageSize: pageSize,
            page: page,
            sortBy: sortBy,
            sortType: sortOrder,
            sortOrder: sortOrder,
            sortAscending: sortAscending,
            totalPages: totalPages,
            totalItems: totalItems,
            startIndex: startIndex,
            endIndex: endIndex,
            filterMin: filterMin,
            filterMax: filterMax,
            appliedFilters: filters,
            prefix: prefix
        };
    }

    function updateControls(data) {
        var pagerModel = data.pagination;
        if (pagerModel) {

            if (pagerModel.totalPages) {
                totalPages = pagerModel.totalPages;
            }

            totalItems = pagerModel.totalItems;

            startIndex = (pagerModel.page - 1) * pagerModel.pageSize + 1;
            if (startIndex === 0) {
                startIndex = 1;
            }
            endIndex = startIndex + pagerModel.pageSize - 1;
            if (endIndex > totalItems) {
                endIndex = totalItems;
            }

            $(prefix + ' .startIndex').text(startIndex);
            $(prefix + ' .endIndex').text(endIndex);
            $(prefix + ' .totalItemsCount').text(totalItems);
            $(prefix + ' .pageNum').val(pagerModel.page);
        }
    }

    function getCurrentSortValue(context) {
        var optionSelected = {};
        if (context) {
            optionSelected = $('option:selected', context);
        } else {
            optionSelected = $(prefix + ' .roc-sort option:selected');
        }
        if (optionSelected.length > 0) {
            // override our sort behavior if the dom is specifying our sort info
            sortBy = optionSelected.attr('data-sortBy');
            sortOrder = optionSelected.attr('data-sortType');
            sortAscending = optionSelected.attr('data-sortascending');
        }
    }

    function sortChangeEvt() {
        var selector = prefix + ' #itemsSort';
        $(document)
            .off('change', selector)
            .on('change', selector, function () {

                getCurrentSortValue(this);
                callback(getPagingObj());
                return false;
        });

        selector = prefix + ' .roc-sort';
        $(document)
            .off('change', selector)
            .on('change', selector, function () {

                page = 1;
                getCurrentSortValue(this);
                callback(getPagingObj());
                return false;
        });
    }

    function getCurrentFilters() {
        filters = [];
        $('.roc-filter').each(function () {
            filters.push({
                key: $(this).attr('data-roc-filter'),
                value: $('option:selected', this).attr('data-value') || $(this).attr('data-roc-value') || $(this).val(),
                isVisible: $(this).attr('data-roc-visible')
            });
        });
    }

    function filterChangeEvt() {
        var selector = prefix + ' #itemFilter';
        $(document)
            .off('change', selector)
            .on('change', selector, function () {

                var optionSelected = $('option:selected', this);
                filterMin = optionSelected.attr('data-filtermin');
                filterMax = optionSelected.attr('data-filtermax');
                callback(getPagingObj());
                return false;
        });

        selector = prefix + ' .roc-filter';
        $(document)
            .off('change', selector)
            .on('change', selector, function () {

                page = 1;
                getCurrentFilters();
                callback(getPagingObj(), $(this).attr('data-roc-reload') !== 'false');
                return false;
        });
    }

    function pageNumChangeEvt() {
        var selector = prefix + ' .pagination .pageNum';
        $(document)
            .off('change', selector)
            .on('change', selector, function () {

                var pageNum = parseInt($(this).val());
                if (pageNum > 0 && pageNum <= totalPages) {
                    page = pageNum;
                    callback(getPagingObj(), true);
                } else {
                    $(prefix + ' .paging input[type="number"]').val(page);
                }
                return false;
        });
    }

    function pagination(pageNum) {
        pageNum = parseInt(pageNum);
        if (pageNum > 0 && pageNum <= totalPages) {
            page = pageNum;
            callback(getPagingObj(), true);
            return;
        }
    }

    function prevPageEvt() {
        var selector = prefix + ' .pagination .prev';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {

                var pageNum = page - 1;
                pagination(pageNum);
                return false;
        });
    }

    function nextPageEvt() {
        var selector = prefix + ' .pagination .next';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {

                var pageNum = page + 1;
                pagination(pageNum);
                return false;
        });
    }

    function pageChangeEnterEvt() {
        var selector = prefix + ' .pagination .paging input';
        $(document)
            .off('keypress', selector)
            .on('keypress', selector, function (e) {

            if (e.keyCode === 13) {
                var pageNum = parseInt($(this).val());
                if (pageNum > 0 && pageNum <= totalPages) {
                    page = pageNum;
                    callback(getPagingObj());
                } else {
                    $(this).val(page);
                }
                $(this).blur();
                return false;
            }

            return true;
        });
    }

    function bindEvents() {
        sortChangeEvt();
        filterChangeEvt();
        prevPageEvt();
        nextPageEvt();
        pageNumChangeEvt();
        pageChangeEnterEvt();
    };

    function init(initData, callback) {
        pageSize = initData.pageSize;
        page = initData.page;
        sortBy = initData.sortBy;
        sortAscending = initData.sortAscending;
        sortOrder = initData.sortType;
        totalPages = initData.totalPages;
        filterMin = initData.filterMin;
        filterMax = initData.filterMax;
        prefix = initData.prefix || '';
        getCurrentFilters();
        getCurrentSortValue();
        setCallback(callback);
        bindEvents();
        return getPagingObj();
    };

    function updatePaging(data) {
        if (data.totalPages) {
            totalPages = data.totalPages;
        }
        updateControls(data);
        return getPagingObj();
    }

    var Pagination = {
        init: init,
        updatePaging: updatePaging
    };

    Logger.debug('Pagination.js Loaded:', Pagination);

    return Pagination;
});

